export const environment = {
    production: false,
   api_url: 'https://flowdecisionhubapp.crif.com.jm',
   origin: 'https://flowdecisionhubapp.crif.com.jm',
   token_url :  'https://flowdecisionhubapp.crif.com.jm/Flexauth',
   iv_encryption_key: '8080808080808080'
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts